import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API_CLIENT from "../../lib/api-client";
import { GET_CATEGORY_BY_ID } from "../../utils/constant";
import Loading from "../../component/loading";

const CategoryDetails = () => {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log(id);
    const fetchCategory = async () => {
      try {
        const response = await API_CLIENT.get(GET_CATEGORY_BY_ID + id);
        console.log(response);
        if (response.status === 200) {
          setCategory(response.data);
          setLoading(false);
        } else {
          setError(response.data.message);
          setLoading(false);
        }
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchCategory();
  }, [id]);

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading && <Loading />}
        {error && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded">
            <p className="font-medium">{error.message || "An error occurred"}</p>
          </div>
        )}
        {category && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Image Section */}
            <div className="rounded-lg overflow-hidden shadow-lg aspect-[4/3] w-full">
              <img
                src={category.imageUrl}
                alt={category.name}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content Section */}
            <div className="space-y-8">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                  {category.name}
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {category.description}
                </p>
              </div>

              {category.subDescription && category.subDescription.length > 0 && (
                <div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Additional Details
                  </h2>
                  <div className="space-y-4">
                    {category.subDescription.map((desc, index) => (
                      <div
                        key={index}
                        className="flex items-start p-4 bg-gray-50 rounded-lg"
                      >
                        <div className="flex-shrink-0 h-8 w-8 flex items-center justify-center rounded-full bg-teal-100 text-teal-700 font-semibold mr-4">
                          {index + 1}
                        </div>
                        <p className="text-gray-700">{desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryDetails;
